import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, findAll, getParent, addClass, removeClass } from '@fretadao/f-js-dom';

application.register(
  'admin-document-field',
  class extends Controller {
    static targets = ['forAllField', 'resourcesBox', 'selectField'];

    connect() {
      this.forAllFieldTarget.addEventListener('change', (event) => { this.#toggleBox(event.target) });
      this.#toggleBox(this.forAllFieldTarget);

      $(this.selectFieldTarget)
        .on('select2:select', this.#handleCategoryChange.bind(this))
        .on('select2:clear', this.#handleCategoryChange.bind(this));
      this.#handleCategoryChange();
    }

    #toggleBox(field) {
      if (field.checked) this.#clearBox();
      else this.#undoClearBox();
    }

    #clearBox() {
      addClass(this.#currentResourcesBox(), 'hide');
      this.#toogleCheckboxesBox(true);
      this.#removeAllNewResources();
    }

    #currentResourcesBox() {
      return this.resourcesBoxTargets.find(target => target.id.includes(this.selectFieldTarget.value))
    }

    #undoClearBox() {
      removeClass(this.#currentResourcesBox(), 'hide');
      this.#toogleCheckboxesBox(false);
    }

    #toogleCheckboxesBox(checked) {
      this.resourcesBoxTarget.querySelectorAll('input[type=checkbox]').forEach(field => field.checked = checked);
    }

    #handleCategoryChange() {
      const companyFields = document.getElementById('company_fields');
      const driverFields = document.getElementById('driver_fields');
      const vehicleFields = document.getElementById('vehicle_fields');

      if (companyFields) addClass(companyFields, 'hide');
      if (driverFields) addClass(driverFields, 'hide');
      if (vehicleFields) addClass(vehicleFields, 'hide');

      if (this.forAllFieldTarget.checked) return;

      switch (this.selectFieldTarget.value) {
        case 'company':
          if (companyFields) removeClass(companyFields, 'hide');
          this.#removeNewResources(driverFields);
          this.#removeNewResources(vehicleFields);
          break;
        case 'driver':
          if (driverFields) removeClass(driverFields, 'hide');
          this.#removeNewResources(companyFields);
          this.#removeNewResources(vehicleFields);
          break;
        case 'vehicle':
          if (vehicleFields) removeClass(vehicleFields, 'hide');
          this.#removeNewResources(driverFields);
          this.#removeNewResources(companyFields);
          break;
      }
    }

    #removeAllNewResources() {
      this.resourcesBoxTargets.forEach((resourcesBox) => {
        this.#removeNewResources(resourcesBox);
      });
    }

    #removeNewResources(resourcesBox) {
      if (!resourcesBox) return;

      resourcesBox.querySelectorAll('fieldset').forEach((fieldset) => {
        if (!fieldset.querySelector('input[type=checkbox]')) fieldset.remove();
      });
    }
  }
)
